export default {
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "ben.marrying.kim"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://1f7ix7bomf.execute-api.us-east-1.amazonaws.com/prod"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_JgL4pWvBq",
    APP_CLIENT_ID: "7nj0v0fela3gii68fk8pt95cp",
    IDENTITY_POOL_ID: "us-east-1:b78b114f-183d-4b7a-89d5-c50e0b004a16"
  }
};



// WEBPACK FOOTER //
// ./config.js